// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"0": "intl-numberformat","218": "intl-pluralrules","223": "intl-locale","228": "confirmation","236": "dates","285": "rates","380": "react-query-devtools","398": "spaceCategories","602": "enterprises","759": "summary","817": "phoneInput","979": "icons",}[chunkId] || chunkId) + ".js"
}